type SVGProps = {
  color?: string;
};

const RunningShoe = ({ color = '#F4F4F7' }: SVGProps) => (
  <svg focusable={false} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 60'>
    <defs>
      <circle id='a' cx='30' cy='30' r='30' />
      <path id='c' d='M.187 16.435l11.586 2.551 5.372-16.281L3.913.1z' />
      <path id='e' d='M.187 16.435l11.586 2.551 5.372-16.281L3.913.1z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <mask id='b' fill='#fff'>
        <use xlinkHref='#a' />
      </mask>
      <use fill={color} xlinkHref='#a' />
      <g mask='url(#b)'>
        <path
          fill='#DFDEDE'
          d='M28.145 24.561l-11.038-2.534 4.712-25.709h15.7z'
        />
        <path
          fill='#6C6D6D'
          d='M17.74 21.613l10.041 2.305L35.976-.6 22.26-3.048l-4.52 24.66zm10.405 3.494a.567.567 0 0 1-.124-.014l-11.038-2.535a.545.545 0 0 1-.416-.629l4.712-25.708a.55.55 0 0 1 .637-.44l14.877 2.657a.543.543 0 0 1 .424.708l-8.551 25.587a.549.549 0 0 1-.521.374z'
        />
        <path
          fill='#FEFEFE'
          d='M28.145 24.561L16.558 22.01l3.727-16.334 13.232 2.603z'
        />
        <path
          fill='#6C6D6D'
          d='M17.215 21.596l10.563 2.326 5.024-15.227-12.1-2.381-3.487 15.282zm10.93 3.51a.556.556 0 0 1-.12-.012L16.44 22.542a.542.542 0 0 1-.417-.653L19.75 5.555a.55.55 0 0 1 .642-.414l13.231 2.603a.543.543 0 0 1 .415.705l-5.372 16.282a.548.548 0 0 1-.521.375z'
        />
        <path
          fill='#FEFEFE'
          d='M28.145 24.561L16.558 22.01l3.727-16.334 13.232 2.603z'
        />
        <g transform='translate(16.372 5.575)'>
          <mask id='d' fill='#fff'>
            <use xlinkHref='#c' />
          </mask>
          <path
            fill='#7C53A5'
            d='M15.823 7.56l-12.9-2.482.208-1.071 12.9 2.483z'
            mask='url(#d)'
          />
        </g>
        <g transform='translate(16.372 5.575)'>
          <mask id='f' fill='#fff'>
            <use xlinkHref='#e' />
          </mask>
          <path
            fill='#7C53A5'
            d='M14.92 9.929L2.566 7.463l.216-1.07L15.135 8.86z'
            mask='url(#f)'
          />
        </g>
        <path
          stroke='#6C6D6D'
          strokeLinejoin='round'
          strokeWidth='1.171'
          d='M28.145 24.561L16.558 22.01l3.727-16.334 13.232 2.603z'
        />
        <path
          fill='#424547'
          d='M41.263 45.188s6.798 1.563 9.795-2.031c-2.42-3.196-41.13-17.398-43.167-12.725-1.09 3.05 2.264 4.707 7.223 6.5l26.149 8.256z'
          opacity='.332'
        />
        <g>
          <path
            fill='#FEFEFE'
            d='M21.319 22.45c1.091.25 2.379.202 3.531.053 1.597-.205 2.965-1.17 3.785-2.547l.025-.04c.456-.746 1.546-.784 2.072-.085.461.614.796 1.164.796 1.164s5.57 9.65 19.337 19.044l.017.011c.076.044.591.402.254 1.901l-.048.14s-3.136 1.384-12.953-3.052l-.058-.026c-9.697-3.825-26.89-11.67-26.89-11.67l.048-.14s1.082-3.05 3.106-5.242c.277-1.32.932-3.653 4.158-4.119'
          />
          <path
            fill='#DFDEDE'
            d='M11.187 27.333s-3.614 2.404-2.686 4.12c0 0 .59 1.639 6.727 4.063.368.145.744.265 1.127.365 2.21.579 10.543 2.811 17.865 5.456 8.634 2.686 15.415 4.167 16.868.744 0 0-3.193 1.358-13.01-3.078-9.697-3.825-26.89-11.67-26.89-11.67'
          />
          <path
            fill='#6C6D6D'
            d='M9.017 31.27c.002 0 .789 1.517 6.414 3.74.333.13.68.243 1.064.344 2.357.616 10.615 2.834 17.913 5.47 6.66 2.072 13.04 3.687 15.413 1.987-1.837.055-5.523-.398-11.97-3.311-8.893-3.507-24.316-10.5-26.606-11.541-1.079.78-2.743 2.344-2.26 3.237a.514.514 0 0 1 .032.074m37.82 13.35c-3.061 0-7.4-1.089-12.78-2.763-7.279-2.628-15.496-4.834-17.842-5.449a10.353 10.353 0 0 1-1.19-.385c-5.807-2.294-6.847-3.932-7.023-4.34-1.084-2.085 2.47-4.53 2.88-4.804a.55.55 0 0 1 .535-.042c.171.078 17.29 7.884 26.864 11.66 9.37 4.233 12.57 3.09 12.6 3.079a.558.558 0 0 1 .597.126.541.541 0 0 1 .116.59c-.695 1.638-2.321 2.329-4.758 2.329'
          />
          <path
            fill='#FEFEFE'
            d='M14.294 22.09s5.332 3.312 3.783 8.346c-1.34-.6-6.89-3.103-6.89-3.103.094-.37.59-2.329 3.107-5.242'
          />
          <path
            fill='#6C6D6D'
            d='M11.848 27.032c1.153.52 4.306 1.942 5.857 2.64.334-1.69-.12-3.348-1.353-4.937a10.462 10.462 0 0 0-1.962-1.91c-1.568 1.892-2.248 3.333-2.542 4.207m6.229 3.95a.553.553 0 0 1-.225-.049c-1.341-.6-6.891-3.104-6.891-3.104a.545.545 0 0 1-.306-.63c.402-1.583 1.546-3.523 3.222-5.464a.551.551 0 0 1 .707-.107c.058.036 1.43.897 2.616 2.413 1.605 2.052 2.09 4.319 1.402 6.554a.547.547 0 0 1-.525.386'
          />
          <path
            fill='#6C6D6D'
            d='M50.638 41.652c-.869.177-4.327.483-12.277-3.11l-.08-.036c-8.689-3.427-23.592-10.172-26.402-11.448.333-.827 1.32-3.052 2.866-4.728a.544.544 0 0 0 .133-.257c.332-1.58 1.016-3.242 3.548-3.667.032.105.048.294.035.43-.165 1.178.193 3.56 2.734 4.145 1.005.231 2.259.253 3.726.063 1.73-.223 3.256-1.247 4.186-2.81l.021-.035a.678.678 0 0 1 .556-.322c.24-.01.465.09.609.281.435.58.76 1.108.76 1.108.02.035.756 1.286 2.302 3.299l-1.91 1.553a.543.543 0 0 0-.078.768.548.548 0 0 0 .772.076l1.891-1.536c.28.349.581.717.903 1.1l-2.004 1.628a.543.543 0 0 0-.077.767.548.548 0 0 0 .772.077l2.018-1.64c.297.342.613.696.942 1.058L34.71 29.94a.543.543 0 0 0 .348.968c.122 0 .245-.04.347-.123l1.92-1.562c3.116 3.33 7.465 7.333 13.227 11.266.007.005.02.012.03.02.07.076.193.407.056 1.144m-35.616-23.91a1.01 1.01 0 0 1 .514-1.138 1.023 1.023 0 0 1 1.384.42 1 1 0 0 1 .104.631 4.8 4.8 0 0 0-1.783 1.158 12.288 12.288 0 0 0-.219-1.07M51.175 39.59c-13.488-9.206-19.116-18.771-19.177-18.878a16.38 16.38 0 0 0-.827-1.207 1.806 1.806 0 0 0-1.54-.718 1.782 1.782 0 0 0-1.438.841l-.03.05c-.758 1.272-1.99 2.105-3.383 2.285-1.338.172-2.46.157-3.337-.045-2.192-.504-1.908-2.834-1.893-2.95.016-.146.072-.894-.324-1.342a.96.96 0 0 0-.806-.323 7.41 7.41 0 0 0-.29.048 2.104 2.104 0 0 0-1.494-1.863 2.118 2.118 0 0 0-1.615.155 2.097 2.097 0 0 0-1.062 2.368c.003.012.316 1.222.303 2.19h.049a7.257 7.257 0 0 0-.477 1.503c-2.01 2.237-3.072 5.191-3.117 5.318a.029.029 0 0 0-.002.005l-.048.14a.544.544 0 0 0 .29.671c.173.079 17.318 7.895 26.894 11.672l.056.025c6.08 2.748 9.688 3.298 11.604 3.298 1.212 0 1.746-.22 1.8-.244a.546.546 0 0 0 .296-.322l.048-.14a.683.683 0 0 0 .016-.057c.406-1.803-.29-2.363-.496-2.48'
          />
          <path
            fill='#FEFEFE'
            d='M33.07 10.572l-13.56-2.61a1.348 1.348 0 0 1-1.074-1.58l.032-.165a1.355 1.355 0 0 1 1.59-1.067l13.56 2.61a1.348 1.348 0 0 1 1.073 1.58l-.032.165a1.355 1.355 0 0 1-1.589 1.067'
          />
          <path
            fill='#6C6D6D'
            d='M33.175 10.036a.804.804 0 0 0 .945-.635l.033-.165a.801.801 0 0 0-.639-.94l-13.561-2.61a.81.81 0 0 0-.946.635l-.032.165a.805.805 0 0 0 .639.94l13.56 2.61zm.157 1.106a1.94 1.94 0 0 1-.366-.035l-13.561-2.61a1.894 1.894 0 0 1-1.508-2.219l.032-.165a1.88 1.88 0 0 1 .804-1.209 1.9 1.9 0 0 1 1.428-.29l13.562 2.611a1.894 1.894 0 0 1 1.507 2.219l-.032.165a1.88 1.88 0 0 1-.804 1.208 1.9 1.9 0 0 1-1.062.325z'
          />
        </g>
      </g>
    </g>
  </svg>
);

export default RunningShoe;
